module.exports = __webpack_public_path__ + "img/indice_c_aire_hover.770909a6.png";